import { render, staticRenderFns } from "./Tour.vue?vue&type=template&id=eeff27b8&scoped=true"
import script from "./Tour.vue?vue&type=script&lang=js"
export * from "./Tour.vue?vue&type=script&lang=js"
import style0 from "./Tour.vue?vue&type=style&index=0&id=eeff27b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeff27b8",
  null
  
)

export default component.exports